var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('value-combo-box',_vm._b({attrs:{"items":_vm.items,"label":"Targeting"},on:{"input":function($event){return _vm.$emit('input', $event)}}},'value-combo-box',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }